import { createFileRoute } from '@tanstack/react-router';

import {
  AudienceLibraryPage,
  audienceLibrarySearchParamsSchema,
} from '@/features/audienceLibrary';

export const Route = createFileRoute('/_app/audience-library')({
  validateSearch: audienceLibrarySearchParamsSchema,
  component: RouteComponent,
});

function RouteComponent() {
  return <AudienceLibraryPage />;
}
